export const COMPONENT_MATCHING_IMPORT_BASE_PATH =
  "/onboarding/component-matching-import";

export const COMPONENT_MATCHING_IMPORT_DISPLAY_NAME = "Component Matching Import";
